import { SelectInput, Text } from '@digitools/honest-ui';
import React from 'react';
import HonestUploadButton from 'src/components/documentUpload/HonestUploadButton';
import useExperience from 'src/hooks/useExperience';
import useTranslate from 'src/hooks/useTranslate';
import { Language } from 'src/types/Language';
import { DocumentUploadDisplayTextEn } from './language/DocumentUploadDisplayTextEn';
import { DocumentUploadDisplayTextEs } from './language/DocumentUploadDisplayTextEs';
// @ts-ignore
import Styles from './HonestInlineDocumentUpload.scss';
/** honest-ui rebrand of `./SelectCategory`, alongside the original until every upload feature is converted. */
const HonestSelectCategory = ({ categoryList, uploading, documentCategory, uploadedFiles, eventNum, onUpload, setDocumentCategory, }) => {
    const { t } = useTranslate();
    const { language } = useExperience();
    const languageFile = language === Language.SPANISH ? DocumentUploadDisplayTextEs : DocumentUploadDisplayTextEn;
    const showCategory = uploadedFiles?.length < 10 && !uploading && t(categoryList) && t(categoryList).length !== 1;
    return (<>
      {showCategory && (<div className={Styles.categoryRow}>
          <Text as='span' className={Styles.categorySerial}>
            {uploadedFiles.length + 1}
          </Text>
          <SelectInput label={languageFile.labelName} name={'documentCategory'} options={t(categoryList)} data-testid={'documentCategory'} onChange={value => setDocumentCategory(value)} placeholder={t({
                english: 'Select document type',
                spanish: 'Seleccione un tipo de documento',
            })} defaultValue={''}/>
        </div>)}
      {(documentCategory || (categoryList && t(categoryList).length == 1)) && !uploading && (<HonestUploadButton onUpload={onUpload} eventNum={eventNum}/>)}
    </>);
};
export default HonestSelectCategory;
